import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import Dashboard from './Dashboard'; // The logged-in user's dashboard
import GuestDashboard from './GuestDashboard'; // The public dashboard

const HomePage = () => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading session...</div>;
    }

    // If the user is logged in, show them the full dashboard.
    // Otherwise, show them the public guest dashboard.
    return isAuthenticated ? <Dashboard /> : <GuestDashboard />;
};

export default HomePage;
